<template>
    <div class="sign_wrap" v-show="isShow">
        <div class="sign_left"><SignInfo :collectinfo="collectinfo" :eventticketinfo="eventticketinfo" :formList="formList"></SignInfo></div>
        <div class="sign_right"><OderDet :collectinfo="collectinfo" :eventinfo="eventinfo" :eventticketinfo="eventticketinfo" :formList="formList"></OderDet></div>
    </div>
</template>

<script>
    import {getConfirmOrderinfo} from 'api/hdApi'
    import {mapGetters,mapActions} from 'vuex'
    import SignInfo from '@/views/hdPc/components/signInfo'
    import OderDet from '@/views/hdPc/components/oderDet'
    export default {
        name: "SignForm",
        data(){
            return{
                isShow:false,
                eventinfo:{}, //活动基本信息
                eventticketinfo:{}, //票种信息
                collectinfo :{}, //名单收集信息
                collist :{}, //表单列表
                formList:[],
            }
        },
        mounted(){
          this._getInfo()
        },
        methods:{
            //获取报名信息
            _getInfo(){
                this.setLoading(true);
                let param={
                    eventid:this.$route.query.eventid,
                    ticketcount:this.$route.query.ticketcount,
                    ticketid:this.$route.query.ticketid,
                };
                getConfirmOrderinfo({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false)
                        this.isShow=true
                        this.eventinfo=data.data.eventinfo;
                        this.eventticketinfo =data.data.eventticketinfo;
                        this.collectinfo =data.data.collectinfo;
                        //修改数据格式，新增姓名手机号
                        this.formList.push({
                          joinername: '',
                          joinermobile: '',
                          isopen: true,
                          formdata: data.data.collist
                        })
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading',
                'setLoginPop',
                'setUser'
            ])
        },
        computed: {
            ...mapGetters(['loginPop', 'user','domainInfo'])
        },
        components: {
            SignInfo,OderDet
        }
    }
</script>

<style lang="scss">
    .sign_wrap{
        width: 1200px;
        margin: auto;
        display: flex;
        padding: 30px 0;
        overflow: hidden;
    }
    .sign_wrap>div{
        flex: 1;
    }
</style>